import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppMaterialModule } from '../../app-material.module';
import { DirectivesModule } from '../../directives/directives.module';
import { ServicesModule } from '../../services/services.module';
import { AssetIconModule } from '../asset-icon/asset-icon.module';
import { ToolActionComponent } from './tool-action/tool-action.component';
import { ToolbarComponent } from './toolbar.component';
import { ToolbarWidgetWrapperComponent } from './widget-wrapper/toolbar-widget-wrapper.component';

function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  imports: [
  CommonModule,
  AppMaterialModule,
  DirectivesModule,
  MatProgressSpinnerModule,
  ServicesModule,
  AssetIconModule,
  TranslateModule.forRoot({
    loader: {
    provide: TranslateLoader,
    useFactory: HttpLoaderFactory,
    deps: [HttpClient]
    }
    }),
  ],
  declarations: [
  ToolbarWidgetWrapperComponent,
  ToolActionComponent,
  ToolbarComponent,
  ],
  exports: [
  ToolbarComponent,
  ],
  })
export class ToolbarModule {
}
